import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useCart } from '../../context/CartContext';
import { FaShoppingCart, FaUserCircle, FaSearch } from 'react-icons/fa';
import Logo from '../../Assest/sumber-lancar.png';
import './Navbar.css';
const Navbar = () => {
  const { isAuthenticated, user } = useAuth();
  const { cartCount } = useCart();
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        
        {/* Logo */}
        <Link to="/" className="navbar-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={Logo} alt='' />
          <div className="logo-text">
            <span>Sumber</span>
            <span>Lancar</span>
          </div>
        </Link>

        {/* Search Bar */}
        <form className="navbar-search" onSubmit={handleSearch}>
          <div className="search-group">
            <input
              type="text"
              placeholder="Cari di Sumber Lancar..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button type="submit" className="search-btn">
              <FaSearch />
            </button>
          </div>
        </form>

        {/* Right Menu */}
        <nav className="navbar-menu">
          <NavLink to="/cart" className="navbar-icon cart">
            <FaShoppingCart />
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </NavLink>

          {isAuthenticated ? (
            <NavLink to="/profile" className="navbar-icon profile">
              <FaUserCircle />
              <span className="profile-name">Hi, {user.name.split(' ')[0]}</span>
            </NavLink>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="btn">Login</Link>
              <Link to="/register" className="btn primary">Register</Link>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
